import ErrorDisplay from '../../components/error/ErrorDisplay'

import styles from './Error.module.css'
import { DialogWrapper } from '../../components/general/DialogWrapper'

/**
 * @typedef {interface} ErrorParams
 * @prop {string} title
 * @prop {Error | null} what
 * @prop {boolean} isOpen
 * @prop {callback} closeModal
 */
interface ErrorParams {
  title: string
  what: Error | null
  isOpen: boolean
  closeModal: () => void
}

/**
 * @param {ErrorParams}
 * @returns {JSX.Element}
 */
export default function Error({ title, what, isOpen, closeModal }: ErrorParams): JSX.Element {
  return (
    <DialogWrapper isOpen={isOpen} closeModal={closeModal}>
      {what ? (
        <ErrorDisplay title={title} err={what}>
          <div className={styles.errorButtons}>
            <button onClick={closeModal} className={styles.errorBtnClose}>
              That's okay, I'll move on
            </button>
            <button onClick={closeModal} className={styles.errorBtnReport}>
              That's rather annoying, please investigate this
            </button>
          </div>
        </ErrorDisplay>
      ) : null}
    </DialogWrapper>
  )
}
